class @App.Components.VideoSearchLoading
  constructor: ->
    @container = $('#video_search').find('.videos-loading')
    @loading_text = @container.find('.loading-text')
    @spinner = new App.Components.LoadingIndicator
      container: @container.find('.loading-spinner')
      length: 3
      width: 2
      radius: 5
      top: '10px'
      left: '4px'
      color: '#555555'

    @spinner.show()

    @bindEvents()

  bindEvents: =>
    $(document).on 'App::Components::VideoSearch::search_submit', (e) =>
      @show(e)

    $(document).on 'App::Components::VideoPreview::show', (e) =>
      @show(e)

    $(document).on 'App::Components::VideoPreview::shown', (e) =>
      @hide(e)

    $(document).on 'App::Components::VideoSearch::before_send', (e) =>
      @show(e)

    $(document).on 'App::Components::VideoSearch::complete', (e) =>
      @hide(e)

    $(document).on 'App::Components::VideoSearch::success', (e) =>
      $.scrollTo($("#search"), 250)
      @hide(e)

  hide: (e) =>
    @container.hide()

  show: (e) =>
    @loading_text.text (if e.text then e.text else 'Searching')
    @container.show()
